/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type FccRequestCabinVideoStreamCredentialsMutationVariables =
  Types.Exact<{
    input: Types.RequestCabinVideoStreamCredentials
  }>

export type FccRequestCabinVideoStreamCredentialsMutation = {
  __typename?: 'Mutation'
  fccRequestCabinVideoStreamCredentials: string
}

export const FccRequestCabinVideoStreamCredentialsDocument = gql`
    mutation fccRequestCabinVideoStreamCredentials($input: RequestCabinVideoStreamCredentials!) {
  fccRequestCabinVideoStreamCredentials(input: $input)
}
    `
export type FccRequestCabinVideoStreamCredentialsMutationFn =
  Apollo.MutationFunction<
    FccRequestCabinVideoStreamCredentialsMutation,
    FccRequestCabinVideoStreamCredentialsMutationVariables
  >

/**
 * __useFccRequestCabinVideoStreamCredentialsMutation__
 *
 * To run a mutation, you first call `useFccRequestCabinVideoStreamCredentialsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFccRequestCabinVideoStreamCredentialsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fccRequestCabinVideoStreamCredentialsMutation, { data, loading, error }] = useFccRequestCabinVideoStreamCredentialsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFccRequestCabinVideoStreamCredentialsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    FccRequestCabinVideoStreamCredentialsMutation,
    FccRequestCabinVideoStreamCredentialsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    FccRequestCabinVideoStreamCredentialsMutation,
    FccRequestCabinVideoStreamCredentialsMutationVariables
  >(FccRequestCabinVideoStreamCredentialsDocument, options)
}
export type FccRequestCabinVideoStreamCredentialsMutationHookResult =
  ReturnType<typeof useFccRequestCabinVideoStreamCredentialsMutation>
export type FccRequestCabinVideoStreamCredentialsMutationResult =
  Apollo.MutationResult<FccRequestCabinVideoStreamCredentialsMutation>
export type FccRequestCabinVideoStreamCredentialsMutationOptions =
  Apollo.BaseMutationOptions<
    FccRequestCabinVideoStreamCredentialsMutation,
    FccRequestCabinVideoStreamCredentialsMutationVariables
  >
